module.exports = __webpack_public_path__ + "img/as.dc3f2bcf.svg";